<template>
    <div>
        <v-card>
            <v-toolbar flat color="primary" dark height="40" >
                <v-toolbar-title>Documents</v-toolbar-title>
                <v-spacer></v-spacer>
                <span class="warning--text">
                    {{quoteData.basicInfo.hideTotalAmtInPdf?"Total Amount in Pdf Quote Was Hidden":""}}
                </span>
            </v-toolbar>
            <v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-alert
                        :value="seePriceAlert"
                        type="error"
                        >
                        The total amount of this Quote is $0.00. Please make sure it is right before you generate pdf quote!
                        </v-alert>

                    </v-flex>
                    <v-flex xs12 v-show="quoteData && quoteData.basicInfo.quotedByCompany === 'LTA'">
                        <v-alert
                        value="true"
                        type="warning"
                        outline
                        >
                        <v-layout row>
                            <v-flex xs2>
                                <v-img
                                :src="require('@/assets/lta_Logo.png')"
                                contain
                                height="30" 
                                ></v-img>
                            </v-flex>
                            <v-flex>This is a LTA PDF Quote!</v-flex>
                        </v-layout>
                        <span></span>
                        </v-alert>
                    </v-flex>
                    <v-flex class="text-xs-center primary--text" xs12>
                        <div>
                                <!-- only developer can see -->
                                <v-btn @click.prevent="showQuoteDocPreview=true" color="primary" 
                                v-show="seeDocPreviewBtn">Preview Quote (developer only)</v-btn>
                            <!-- <v-btn @click.prevent="onPreview" color="primary" v-show="seeDocPreviewBtn">Preview</v-btn> -->
                            <v-btn v-show="seeGeneratePdfDocBtn" 
                                @click.prevent="onGeneratePdf" color="primary">Generate Pdf Quote</v-btn>
                            <v-btn v-show="seeEmailPdfQuoteBtn" 
                                @click.prevent="onShowSendingEmailPopup" 
                                color="primary">Email Newest Pdf Quote</v-btn>
                            <!-- This Email Quote button was designed for Sales Rep use only -->
                            <!-- <v-btn v-show="seeDirectlyEmailPdfQuoteBtn" 
                                @click.prevent="onShowSendingEmailPopup" 
                                color="primary">Email Quote</v-btn> -->
                            <!-- 20210208, I hide this button since none is using the feature
                            <v-btn @click.prevent="showUploadFilePopup=true" 
                                color="primary">Upload File</v-btn> -->
                            
                        </div>
                    </v-flex>
                </v-layout>

            </v-card-title>
            <v-card-text v-if="quoteData.docs">
                <v-data-table
                    v-bind:headers="docHeaders"
                    :items="quoteData.docs"
                    hide-actions
                    class="elevation-1"
                    >
                    <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.docType }}</td>
                    <td>{{ props.item.createDate | morph-date("MM/DD/YYYY hh:mm a") }}</td>
                    <td class="text-xs-left">{{ props.item.notes }}</td>
                    <td class="text-xs-left">{{ props.item.logs }}</td>
                    <td class="text-xs-left">{{ props.item.by }}</td>
                    <td class="text-xs-left">
                        <a href="#" 
                        @click.prevent="onGetDoc(props.item)"
                        style='text-decoration: none;' title="download document"><v-icon>file_download</v-icon></a>
                    </td>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-text v-else>
                <div class="warning--text">No Record Found</div>
            </v-card-text>
        </v-card>
        <v-dialog v-model="showQuoteDocPreview" width="1040" height="500" color="white">
            <v-card>
                <v-card-title >
                    <v-spacer></v-spacer>
                    <v-btn color="primary" large @click.prevent="showQuoteDocPreview = false">Close Preview</v-btn>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <ctlQuoteDoc :quoteData="quoteData" class="px-2"></ctlQuoteDoc>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showEmailSendingPopup" width="1040" height="500" color="white">
            <ctlSendEmail :initEmailSendingData="initEmailSendingData" 
                @quoteEmailSent="quoteEmailSent"
                @quoteEmailSentPopupClose="showEmailSendingPopup = false" ></ctlSendEmail>
        </v-dialog>
        <v-dialog v-model="showUploadFilePopup" width="400" height="400" color="white">
            <ctlQuoteFileUpload 
                :quoteId="quoteData.id"
                @fileUploaded="fileUploaded"
                @closeFileUpload="showUploadFilePopup = false" ></ctlQuoteFileUpload>
        </v-dialog>
        <!-- {{quoteData.nextActions}} -->
        <!-- {{canProcessPdfDoc}}-{{userHasSalesRepRole}}-{{seeGeneratePdfDocBtn}} -->
    </div>
</template>
<script>
import ctlQuoteDoc from "@/components/ctlQuoteDoc.vue";
import ctlSendEmail from "@/components/ctlSendEmail";
import ctlQuoteFileUpload from "@/components/ctlQuoteFileUpload";
import { mapGetters, mapActions } from 'vuex'
import ApiService from "@/services/api.service"

export default {
    props: ['quoteData'],
    components: {
        ctlQuoteDoc: ctlQuoteDoc,
        ctlSendEmail: ctlSendEmail,
        ctlQuoteFileUpload: ctlQuoteFileUpload,
    },
    data () {
        return {
            showQuoteDocPreview: false,
            showEmailSendingPopup: false,
            showUploadFilePopup: false,
            docHeaders: [
                { text: 'Type', value: 'docType', align: 'left', sortable: false },
                { text: 'Date', value: 'date', align: 'left', sortable: false },
                { text: 'notes', value: 'notes', align: 'left', sortable: false },
                { text: 'logs', value: 'logs', align: 'left', sortable: false },
                { text: 'By', value: 'by', align: 'left', sortable: false },
                { text: 'Download', value: 'path', align: 'left', sortable: false }
            ],
            initEmailSendingData: {
                toEmails: [],
                ccEmails: [],
                attachments: []
            },
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasInternalRole',
            'userHasSalesRepRole',
            'userHasSalesQuoteManagerRole',
            'userData'
        ]),
        seeDocPreviewBtn () {
            return this.userData.userName == 'jshi'
        },
        seeGeneratePdfDocBtn () {
            return this.canProcessPdfDoc
                //this.seeDocPreviewBtn && 
                && (this.userHasInternalRole || this.userHasSalesQuoteManagerRole
                    || this.userHasSalesRepRole)    //20210208, allow Sales Rep see this button
        },
        // seeDirectlyEmailPdfQuoteBtn () {
        //     return this.canProcessPdfDoc
        //         //this.seeDocPreviewBtn && 
        //         && (this.userHasSalesRepRole)            
        // },
        seePriceAlert () {
            if (this.seeGeneratePdfDocBtn) {
                //we allow custom PO has total = 0
                if (this.quoteData.basicInfo.isCustomQuote) {
                    return false
                }

                return !this.quoteData.basicInfo.totalAmount

            }
            return false
        },
        //why I need check this status?
        //if the NextActions Contains this action, it means 
        //we have discountApproval or managerapproval (amt>=$5000) finished,
        //we can generate pdf quote...
        canProcessPdfDoc () {
            //20210209, to sales rep, they can send email
            if(this.userHasSalesRepRole && this.quoteData.basicInfo.statusId == 'Processing') {
                return true
            }
            
            return this.quoteData.nextActions? 
                this.quoteData.nextActions.some(item => item.action === "Send to Customer")
                : false
        },
        newestQuoteDoc () {
            return this.quoteData.docs.some(item => item.docType === "Quotation");
        },
        quoteHasPdfGeneratedAlready () {
            return this.quoteData.docs == null? false :
                this.quoteData.docs.some(d => d.docType == 'Quotation')
        },
        seeEmailPdfQuoteBtn () {
            return this.canProcessPdfDoc
                // (this.quoteData.basicInfo.statusId == 'DiscountApproved' || 
                // this.quoteData.basicInfo.statusId == 'ManagerApproved' || 
                // this.quoteData.basicInfo.statusId == 'Processing' || 
                // this.quoteData.basicInfo.statusId == 'SentToCustomer' || 
                // this.quoteData.basicInfo.statusId == 'Won') 
                && (this.userHasInternalRole || this.userHasSalesQuoteManagerRole || this.userHasSalesRepRole)
                && this.quoteHasPdfGeneratedAlready
        }
    },
    methods: {
        ...mapActions('quoteWorkflow', [
            'generateQuotePdf',
            'getInitQuoteSendingEmailData',
        ]),
        async onGeneratePdf () {
            var result = await this.generateQuotePdf(this.quoteData.id)
            this.$emit('quoteDocGenerated')
        },
        quoteEmailSent () {
            this.showEmailSendingPopup = false

            this.$emit('quoteEmailSent')
        },
        fileUploaded () {
            this.$emit('fileUploaded')
        },
        onGetDoc(fileData) {
            var data = {
                method: 'GET',
                url: fileData.path,
                responseType: 'blob'
            }
            ApiService.customRequest(data)
            .then((response) => {
                if (!window.navigator.msSaveOrOpenBlob){
                    // BLOB NAVIGATOR
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileData.fileName);//'download.pdf');
                    document.body.appendChild(link);
                    link.click();
                }else{
                    // BLOB FOR EXPLORER 11
                    const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]),fileData.fileName);//"download.pdf");
                }
                });
        },
        async onShowSendingEmailPopup () {
            //populate default data
            this.initEmailSendingData = await this.getInitQuoteSendingEmailData(this.quoteData.id)

            this.showEmailSendingPopup = true
        },
        // onPreview () {
        //     this.$router.push({ name: 'quote-doc', params: { id: this.quoteData.id }, query: {} })
        //  }
    },
}
</script>
